import { Envelope } from "../geography";
import { TileAddress } from "./address/tiles.address";
import { Bounds } from "../geometry";
export class Tile extends TileAddress {
    static BuildEnvelope(t, metrics) {
        if (metrics) {
            if (metrics.geoBoundsFactory) {
                const b = metrics.geoBoundsFactory(t, metrics);
                if (b) {
                    return b;
                }
            }
            const a = t.address;
            const nw = metrics.getTileXYToLatLon(a.x, a.y, a.levelOfDetail);
            const se = metrics.getTileXYToLatLon(a.x + 1, a.y + 1, a.levelOfDetail);
            return Envelope.FromPoints(nw, se);
        }
        return undefined;
    }
    static BuildBounds(t, metrics) {
        if (metrics) {
            if (metrics.boundsFactory) {
                const b = metrics.boundsFactory(t, metrics);
                if (b) {
                    return b;
                }
            }
            const a = t.address;
            const p = metrics.getTileXYToPointXY(a.x, a.y);
            return new Bounds(p.x, p.y, metrics.tileSize, metrics.tileSize);
        }
        return undefined;
    }
    constructor(x, y, levelOfDetail, data = null, metrics) {
        super(x, y, levelOfDetail);
        this._value = data;
        if (metrics) {
            this._env = Tile.BuildEnvelope(this, metrics);
            this._rect = Tile.BuildBounds(this, metrics);
        }
    }
    get namespace() {
        return this._ns || "";
    }
    set namespace(v) {
        this._ns = v;
    }
    get address() {
        return this;
    }
    get content() {
        return this._value;
    }
    set content(v) {
        this._value = v;
    }
    get geoBounds() {
        return this._env;
    }
    set geoBounds(e) {
        this._env = e;
    }
    get boundingBox() {
        return this._rect;
    }
    set boundingBox(r) {
        this._rect = r;
    }
}
//# sourceMappingURL=tiles.js.map